module.exports = __webpack_public_path__ + "static/media/gw4.62554775.webp";